var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2318_352)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 25,
    height: 25,
    rx: 5,
    fill: "#273348",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.625 9.125H14.375C14.375 8.89294 14.2828 8.67038 14.1187 8.50628C13.9546 8.34219 13.7321 8.25 13.5 8.25C13.2679 8.25 13.0454 8.34219 12.8813 8.50628C12.7172 8.67038 12.625 8.89294 12.625 9.125ZM11.75 9.125C11.75 8.66087 11.9344 8.21575 12.2626 7.88756C12.5908 7.55937 13.0359 7.375 13.5 7.375C13.9641 7.375 14.4092 7.55937 14.7374 7.88756C15.0656 8.21575 15.25 8.66087 15.25 9.125H18.75C18.866 9.125 18.9773 9.17109 19.0594 9.25314C19.1414 9.33519 19.1875 9.44647 19.1875 9.5625C19.1875 9.67853 19.1414 9.78981 19.0594 9.87186C18.9773 9.95391 18.866 10 18.75 10H18.2565L17.2021 17.7333C17.1306 18.2573 16.8716 18.7377 16.4732 19.0855C16.0747 19.4333 15.5637 19.625 15.0347 19.625H11.9653C11.4363 19.625 10.9253 19.4333 10.5268 19.0855C10.1284 18.7377 9.86939 18.2573 9.79788 17.7333L8.7435 10H8.25C8.13397 10 8.02269 9.95391 7.94064 9.87186C7.85859 9.78981 7.8125 9.67853 7.8125 9.5625C7.8125 9.44647 7.85859 9.33519 7.94064 9.25314C8.02269 9.17109 8.13397 9.125 8.25 9.125H11.75ZM12.625 12.1875C12.625 12.0715 12.5789 11.9602 12.4969 11.8781C12.4148 11.7961 12.3035 11.75 12.1875 11.75C12.0715 11.75 11.9602 11.7961 11.8781 11.8781C11.7961 11.9602 11.75 12.0715 11.75 12.1875V16.5625C11.75 16.6785 11.7961 16.7898 11.8781 16.8719C11.9602 16.9539 12.0715 17 12.1875 17C12.3035 17 12.4148 16.9539 12.4969 16.8719C12.5789 16.7898 12.625 16.6785 12.625 16.5625V12.1875ZM14.8125 11.75C14.9285 11.75 15.0398 11.7961 15.1219 11.8781C15.2039 11.9602 15.25 12.0715 15.25 12.1875V16.5625C15.25 16.6785 15.2039 16.7898 15.1219 16.8719C15.0398 16.9539 14.9285 17 14.8125 17C14.6965 17 14.5852 16.9539 14.5031 16.8719C14.4211 16.7898 14.375 16.6785 14.375 16.5625V12.1875C14.375 12.0715 14.4211 11.9602 14.5031 11.8781C14.5852 11.7961 14.6965 11.75 14.8125 11.75ZM10.665 17.6151C10.7079 17.9295 10.8633 18.2177 11.1024 18.4263C11.3414 18.635 11.648 18.75 11.9653 18.75H15.0347C15.3522 18.7502 15.6589 18.6353 15.8982 18.4266C16.1374 18.218 16.2929 17.9297 16.3359 17.6151L17.3736 10H9.62637L10.665 17.6151Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2318_352",
    x: 0,
    y: 0,
    width: 27,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2318_352"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2318_352",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcons);
export default __webpack_public_path__ + "static/media/Delete-Icons.d50d27f4e8a7731bec6cde86ac72ec66.svg";
export { ForwardRef as ReactComponent };